import { AdvancedMarker, AdvancedMarkerProps, useAdvancedMarkerRef } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

const AdvancedMarkerWithRef = (props: Props) => {
    const { children, onMarkerClick, getRef, ...advancedMarkerProps } = props;
    const [markerRef, marker] = useAdvancedMarkerRef();

    useEffect(() => {
        if (marker) {
            getRef(marker);
        }
    }, [marker, getRef]);

    return (
        <AdvancedMarker
            onClick={() => {
                if (marker) {
                    onMarkerClick(marker);
                }
            }}
            ref={markerRef}
            {...advancedMarkerProps}>
            {children}
        </AdvancedMarker>
    );
};

type Props = AdvancedMarkerProps & {
    onMarkerClick: (marker: google.maps.marker.AdvancedMarkerElement) => void;
    getRef: (adv: google.maps.marker.AdvancedMarkerElement) => void;
};

export default AdvancedMarkerWithRef;